import KnownInternalNames from '@layerswap/utils/known-ids';
import { stellarWalletConnectChain } from '@layerswap/wallet-stellar';
import { defineWalletDescriptor } from './defineWalletDescriptor';
import { readStorageJson } from './persistedSession';
const STELLAR_NETWORKS = [KnownInternalNames.Networks.StellarMainnet, KnownInternalNames.Networks.StellarTestnet];
const STELLAR_SESSION_KEY = 'layerswap:stellar-wallet';
export function createStellarDescriptor(walletConnect, options) {
    const supportedNetworks = options?.supportedNetworks ?? STELLAR_NETWORKS;
    return defineWalletDescriptor({
        id: 'stellar',
        name: 'Stellar',
        capabilities: walletConnect?.projectId ? {
            walletConnectRegistry: {
                networkTypes: [stellarWalletConnectChain.networkType],
            },
        } : undefined,
        autofillSupportedNetworks: supportedNetworks,
        withdrawalSupportedNetworks: supportedNetworks,
        asSourceSupportedNetworks: supportedNetworks,
        hasPersistedSession: () => {
            const persisted = readStorageJson(STELLAR_SESSION_KEY);
            return typeof persisted?.walletId === 'string' && typeof persisted.address === 'string';
        },
        loadProvider: async () => {
            const mod = await import('@layerswap/wallet-stellar');
            return mod.createStellarProvider({ walletConnect });
        },
    });
}
